const DefaultFailedSiteState = {
  payload: {
    initialLoading: true,
    flashMessage: null,
    error: "",
    success: "",
  },
  params: {
    limit: 25,
    page: 1,
    sort_order: "desc",
    q: ``,
    sort_by: ``,
  },
  modal: {
    mode: "",
  },
  status_modal: {
    mode: "",
  },
  fields: [
    { field: `job_id`, label: `Job Id`, sort: true },
    { field: `event`, label: `Event`, sort: true },
    { field: `created_at`, label: `Created At`, sort: true },
    { field: `updated_at`, label: `Updated At`, sort: true },
    { field: `status`, label: `Status`, sort: true },
  ],
};

export const FailedSiteState = { data: DefaultFailedSiteState };
